var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"step-status"},[(_vm.isValid)?_c('img',{attrs:{"src":require("@/assets/icons/status-validated.svg"),"alt":"Complete"}}):_c('img',{attrs:{"src":require("@/assets/icons/status-uncomplete.svg"),"alt":"Uncomplete"}})])}
var staticRenderFns = []

export { render, staticRenderFns }